"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSocialClient = void 0;
const client_1 = require("@dcl/rpc/dist/client");
const codegen_1 = require("@dcl/rpc/dist/codegen");
const errors_1 = require("./errors");
const friendships_gen_1 = require("./protobuff-types/decentraland/social/friendships/friendships.gen");
const synapse_1 = require("./synapse");
const transport_1 = require("./transport");
async function createSocialClient(synapseUrl, socialClientRpcUrl, userAddress, identity) {
    const synapseToken = await (0, synapse_1.getSynapseToken)(synapseUrl, userAddress, identity);
    const webSocketsTransport = (0, transport_1.createWebSocketsTransport)(socialClientRpcUrl);
    const rpcClient = await (0, client_1.createRpcClient)(webSocketsTransport);
    const port = await rpcClient.createPort('social');
    const service = (0, codegen_1.loadService)(port, friendships_gen_1.FriendshipsServiceDefinition);
    return {
        disconnect: () => {
            webSocketsTransport.close();
        },
        getFriends: async function* () {
            const response = service.getFriends(friendships_gen_1.Payload.create({ synapseToken }));
            for await (const friends of response) {
                (0, errors_1.processErrors)(friends);
                yield friends.users?.users ?? [];
            }
        },
        getMutualFriends: async function* (address) {
            const response = service.getMutualFriends(friendships_gen_1.MutualFriendsPayload.create({
                user: { address },
                authToken: { synapseToken }
            }));
            for await (const mutualFriend of response) {
                (0, errors_1.processErrors)(mutualFriend);
                yield mutualFriend.users?.users ?? [];
            }
        },
        getRequestEvents: async () => {
            const response = await service.getRequestEvents(friendships_gen_1.Payload.create({ synapseToken }));
            (0, errors_1.processErrors)(response);
            return response.events;
        },
        requestFriendship: async (address, message) => {
            const response = await service.updateFriendshipEvent({
                event: { request: { user: { address }, message } },
                authToken: { synapseToken }
            });
            (0, errors_1.processErrors)(response);
            return response.event;
        },
        cancelFriendshipRequest: async (address) => {
            const response = await service.updateFriendshipEvent(friendships_gen_1.UpdateFriendshipPayload.create({
                event: { cancel: { user: { address } } },
                authToken: { synapseToken }
            }));
            (0, errors_1.processErrors)(response);
            return response.event;
        },
        acceptFriendshipRequest: async (address) => {
            const response = await service.updateFriendshipEvent(friendships_gen_1.UpdateFriendshipPayload.create({
                event: { accept: { user: { address } } },
                authToken: { synapseToken }
            }));
            (0, errors_1.processErrors)(response);
            return response.event;
        },
        rejectFriendshipRequest: async (address) => {
            const response = await service.updateFriendshipEvent(friendships_gen_1.UpdateFriendshipPayload.create({
                authToken: { synapseToken },
                event: { reject: { user: { address } } }
            }));
            (0, errors_1.processErrors)(response);
            return response.event;
        },
        removeFriend: async (address) => {
            const response = await service.updateFriendshipEvent(friendships_gen_1.UpdateFriendshipPayload.create({
                authToken: { synapseToken },
                event: { delete: { user: { address } } }
            }));
            (0, errors_1.processErrors)(response);
            return response.event;
        },
        subscribeToFriendshipRequests: async function* () {
            const response = service.subscribeFriendshipEventsUpdates(friendships_gen_1.Payload.create({ synapseToken }));
            for await (const friendshipEvent of response) {
                (0, errors_1.processErrors)(friendshipEvent);
                yield friendshipEvent.events?.responses ?? [];
            }
        }
    };
}
exports.createSocialClient = createSocialClient;
//# sourceMappingURL=client.js.map